const privacyPolicy = {
    privacyPolicyHeader: {
        english: 'Privacy Policy',
        sinhala: 'Privacy Policy',
        tamil: 'Privacy Policy',
    }
};

export default privacyPolicy;